import angular from "angular";

export interface ODataArgs<TODataRecord = any> {
	feed?: string;
	filter?: string;
	orderBy?: string | string[] | (keyof TODataRecord)[];
	select?: string | string[] | (keyof TODataRecord)[];
	expand?: string | string[] | (keyof TODataRecord)[];
	top?: number;
	skip?: number;
	inlineCount?: boolean;
	dataScope?: string;
}

export interface ODataResponse<ODataRecord = any> {
	value: ODataRecord[];
}

function commaSeperate<TODataRecord = any>(s: string | string[] | (keyof TODataRecord)[], sort: boolean = false) {
	let array = [];
	if (angular.isArray(s)) {
		array = s;
	} else {
		array = s.split(`,`).map(s => s.trim());
	}
	if (sort) {
		array = array.sort();
	}
	return array;
}

export class ODataBuilder<TODataRecord = any> implements ODataArgs<TODataRecord> {
	feed?: string;
	filter?: string;
	orderBy?: string | string[] | (keyof TODataRecord)[];
	select?: string | string[] | (keyof TODataRecord)[];
	expand?: string | string[] | (keyof TODataRecord)[];
	top?: number;
	skip?: number;
	inlineCount?: boolean;
	dataScope?: string;

	constructor(public baseUrl: string, args: ODataArgs<TODataRecord>) {
		Object.assign(this, args);
	}

	build(): string {
		const args = this;
		let url = this.baseUrl;
		// If feed is not specified, then we assume the baseUrl contains the feed already
		if (args.feed != null) {
			if (!url.endsWith('/')) {
				url += '/';
			}
			url += args.feed;
		}
		let query = [];
		if (args.filter) {
			query.push(`$filter=${args.filter}`); 	// Can't sort the filter, just can't
		}
		if (args.orderBy) {
			query.push(`$orderby=${commaSeperate(args.orderBy)}`);	// Can't sort orderBy, that affects the final result
		}
		if (args.select) {
			query.push(`$select=${commaSeperate(args.select, true)}`);	// By sorting we can generate Urls which are more likely to match other Urls and allow shared caching
		}
		if (args.expand) {
			query.push(`$expand=${commaSeperate(args.expand, true)}`);	// By sorting we can generate Urls which are more likely to match other Urls and allow shared caching
		}
		if (args.top) {
			query.push(`$top=${args.top}`);
		}
		if (args.skip) {
			query.push(`$skip=${args.skip}`);
		}
		if (args.inlineCount) {
			query.push(`$inlinecount=allpages`);
		}
		if (args.dataScope) {
			query.push(`dataScope=${args.dataScope}`);
		}
		if (query.length) {
			url = `${url}?${query.join('&')}`;
		}
		return url;
	}
}